import { useContext } from "react";
import { FormContext } from "./FormContextProvider";
import { InsuranceForm } from "./InsuranceForm";
import PlanComparison from "./PlanComparison";
import Stepper from "./Stepper";
import VehicleForm from "./VehicleForm";

const InsuranceQuotation = () => {
  const { setCurrentStep, currentStep, nextStep } =
    useContext(FormContext);

  const titles = ["Cliente", "Vehículo", "Planes"];

  return (
    <div className="container">
      <Stepper
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        titles={titles}
      >
        <InsuranceForm nextStep={nextStep} />
        <VehicleForm nextStep={nextStep} />
        <PlanComparison />
      </Stepper>
    </div>
  );
};

export default InsuranceQuotation;
